import {
  GET_DEMOS_REQUEST,
  GET_DEMOS_SUCCESS,
  GET_DEMOS_FAILURE,
  GET_DEMO_DETAILS_REQUEST,
  GET_DEMO_DETAILS_SUCCESS,
  GET_DEMO_DETAILS_FAILURE,
  UPLOAD_DEMO_REQUEST,
  UPLOAD_DEMO_SUCCESS,
  UPLOAD_DEMO_FAILURE,
  TOGGLE_DEMO_MODAL,
  SET_SELECTED_DEMO,
  UPDATE_ADDITIONAL_CONTEXT_REQUEST,
  UPDATE_ADDITIONAL_CONTEXT_SUCCESS,
  UPDATE_ADDITIONAL_CONTEXT_FAILURE,
  GET_STATS_REQUEST,
  GET_STATS_SUCCESS,
  GET_STATS_FAILURE,
  REMOVE_DEMO_FAILURE,
  REMOVE_DEMO_SUCCESS,
  REMOVE_DEMO_REQUEST,
  UPDATE_CURRENT_STATUS_SUCCESS,
  SYNC_DEMO_STATUS_SUCCESS,
  UPLOAD_DEMO_PROGRESS,
} from './demoActions';
import { Demo, DemoDetails, DemoStats, ListMeta } from '../../libs/types/src';

interface DemoState {
  list: Demo[];
  listMetaData: ListMeta;
  demosLoading: boolean;
  demosError: string;
  demoDetailsLoading: boolean;
  demoDetailsError: string;
  uploadLoading: boolean;
  uploadError: string;
  uploadProgress: number;
  showDemoModal: boolean;
  selectedDemo: Demo | null;
  demoDetails: DemoDetails | null;
  updateAdditionalContextLoading: boolean;
  updateAdditionalContextError: string;
  statsLoading: boolean;
  statsError: string;
  stats: DemoStats;
  removeDemoLoading: boolean;
  removeDemoError: string;
}

const initialState: DemoState = {
  list: [],
  listMetaData: {
    count: 0,
    page_size: 0,
    page_count: 0,
    has_next: false,
  },
  demosLoading: false,
  demosError: '',
  demoDetailsLoading: false,
  demoDetailsError: '',
  uploadLoading: false,
  uploadError: '',
  uploadProgress: 0,
  showDemoModal: false,
  selectedDemo: null,
  demoDetails: null,
  updateAdditionalContextLoading: false,
  updateAdditionalContextError: '',
  statsLoading: false,
  statsError: '',
  stats: {
    total_demos: 0,
    completed_count: 0,
    key_features_identified: 0,
    avg_analysis_time: 0,
  },
  removeDemoLoading: false,
  removeDemoError: '',
};

export const demoReducers = (state = initialState, action: any): DemoState => {
  switch (action.type) {
    case GET_DEMOS_REQUEST:
      return {
        ...state,
        demosLoading: true,
        demosError: '',
      };

    case GET_DEMOS_SUCCESS:
      return {
        ...state,
        list: action.demos.data || action.demos,
        listMetaData: action.demos.metadata,
        demosLoading: false,
        demosError: '',
      };

    case GET_DEMOS_FAILURE:
      return {
        ...state,
        demosLoading: false,
        demosError: action.error,
      };

    case GET_DEMO_DETAILS_REQUEST:
      return {
        ...state,
        demoDetailsLoading: true,
        demoDetailsError: '',
      };

    case GET_DEMO_DETAILS_SUCCESS:
      return {
        ...state,
        demoDetails: Array.isArray(action.demoDetails.data) ? action?.demoDetails.data[0] : {},
        demoDetailsLoading: false,
        demoDetailsError: '',
      };

    case GET_DEMO_DETAILS_FAILURE:
      return {
        ...state,
        demoDetailsLoading: false,
        demoDetailsError: action.error,
      };

    case UPLOAD_DEMO_REQUEST:
      return {
        ...state,
        uploadLoading: true,
        uploadError: '',
      };

    case UPLOAD_DEMO_SUCCESS:
      return {
        ...state,
        list: [action.demo, ...state.list],
        uploadLoading: false,
        uploadError: '',
      };

    case UPLOAD_DEMO_FAILURE:
      return {
        ...state,
        uploadLoading: false,
        uploadError: action.error,
      };

    case UPLOAD_DEMO_PROGRESS:
      return {
        ...state,
        uploadProgress: action.percent,
      };

    case TOGGLE_DEMO_MODAL:
      return {
        ...state,
        showDemoModal: action.show,
      };

    case SET_SELECTED_DEMO:
      return {
        ...state,
        selectedDemo: action.demo,
      };

    case UPDATE_ADDITIONAL_CONTEXT_REQUEST:
      return {
        ...state,
        updateAdditionalContextLoading: true,
        updateAdditionalContextError: '',
      };

    case UPDATE_ADDITIONAL_CONTEXT_SUCCESS:
      return {
        ...state,
        demoDetails: action.demo,
        updateAdditionalContextLoading: false,
        updateAdditionalContextError: '',
      };

    case UPDATE_ADDITIONAL_CONTEXT_FAILURE:
      return {
        ...state,
        updateAdditionalContextLoading: false,
        updateAdditionalContextError: action.error,
      };

    case GET_STATS_REQUEST:
      return {
        ...state,
        statsLoading: true,
        statsError: '',
      };

    case GET_STATS_SUCCESS:
      return {
        ...state,
        stats: action.stats,
        statsLoading: false,
        statsError: '',
      };

    case GET_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        statsError: action.error,
      };

    case REMOVE_DEMO_REQUEST:
      return {
        ...state,
        removeDemoLoading: true,
        removeDemoError: '',
      };

    case REMOVE_DEMO_SUCCESS:
      return {
        ...state,
        list: state.list.filter((demo: Demo) => demo.id !== action.videoId),
        removeDemoLoading: false,
        removeDemoError: '',
      };

    case REMOVE_DEMO_FAILURE:
      return {
        ...state,
        removeDemoLoading: false,
        removeDemoError: action.error,
      };

    case UPDATE_CURRENT_STATUS_SUCCESS:
      return {
        ...state,
        list: state.list.map((demo: Demo) => demo.id === action.id ? { ...demo, status: action.status } : demo),
      };

    case SYNC_DEMO_STATUS_SUCCESS:
      return {
        ...state,
        list: state.list.map((demo: Demo) => {
          const _demo = action.response.data.find((_demo: Demo) => _demo.id === demo.id);
          if (_demo) {
            return { ...demo, status: _demo.status, video_analysis: _demo.video_analysis };
          }
          return demo;
        }),
      };

    default:
      return state;
  }
}; 